<div class="contract-validation-container">
    <div class="header-bar">
        <button mat-icon-button (click)="openSearch()" matTooltip="Search">
            <mat-icon>search</mat-icon>
        </button>
        <h2 class="contract-title">Contract Number: {{ selectedContract?.contractId || selectedContract?.id }}</h2>
        <div class="spacer"></div>
        <span class="contract-position" id="contract-position" *ngIf="position !== null">{{ position }} of {{ totalCount }}</span>
        <button mat-icon-button (click)="previousContract()" matTooltip="Previous">
            <mat-icon>chevron_left</mat-icon>
        </button>
        <button mat-icon-button (click)="nextContract()" matTooltip="Next">
            <mat-icon>chevron_right</mat-icon>
        </button>
        <button mat-icon-button [matMenuTriggerFor]="menu" matTooltip="Menu">
            <mat-icon>menu</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="save()" [disabled]="isSaving || !selectedContract">
                <mat-icon>save</mat-icon>
                <span>{{ isSaving ? 'Saving...' : 'Save' }}</span>
            </button>
            <button mat-menu-item (click)="approveAll()">
                <mat-icon>check_circle</mat-icon>
                <span>Approve All</span>
            </button>
            <button mat-menu-item (click)="synchronizeAll()" [disabled]="isSyncing">
                <mat-icon>sync</mat-icon>
                <span>{{ isSyncing ? 'Synchronizing...' : 'Synchronize All' }}</span>
            </button>
        </mat-menu>
    </div>

    <div class="state-panel" id="sync-progress" *ngIf="isSyncing">
        <mat-spinner diameter="24"></mat-spinner>
        <span>{{ syncProgress }}</span>
    </div>
    <div class="state-panel" id="list-loading" *ngIf="listState === 'loading'">
        <mat-spinner diameter="24"></mat-spinner>
        <span>Loading contracts...</span>
    </div>
    <div class="state-panel state-error" id="list-error" *ngIf="listState === 'error'">
        <mat-icon>error_outline</mat-icon>
        <span>The contract list could not be loaded.</span>
        <button mat-stroked-button id="list-retry" (click)="retryList()">Retry</button>
    </div>
    <div class="state-panel" id="list-empty" *ngIf="listState === 'empty'">
        <mat-icon>inbox</mat-icon>
        <span>No contracts to show.</span>
    </div>
    <div class="state-panel" id="detail-loading" *ngIf="listState !== 'loading' && detailState === 'loading'">
        <mat-spinner diameter="24"></mat-spinner>
        <span>Loading contract...</span>
    </div>
    <div class="state-panel state-error" id="detail-error" *ngIf="detailState === 'error'">
        <mat-icon>error_outline</mat-icon>
        <span>The contract could not be loaded.</span>
        <button mat-stroked-button id="detail-retry" (click)="retryDetail()">Retry</button>
    </div>

    <div class="content-layout" *ngIf="selectedContract">
        <div class="left-column">
            <mat-card class="section-card">
                <mat-card-header>
                    <mat-card-title>General Contract Conditions per Unit</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <div *ngFor="let field of contractFields; trackBy: trackByFieldKey" class="field-block"
                        [ngClass]="getConfidenceClass(field.confidence)">
                        <div class="field-row">
                            <div class="readonly-field">
                                <span class="readonly-label">
                                    {{ field.label }}
                                    <span class="confidence-pill"
                                        *ngIf="field.confidence !== undefined && field.confidence !== null">
                                        {{ field.confidence | percent:'1.0-0' }}
                                    </span>
                                </span>
                                <span class="readonly-value">{{ field.value || '-' }}</span>
                                <span *ngIf="getFieldValidation(field.key)?.validationStatus"
                                    [class]="getStatusBadgeClass(getFieldValidation(field.key)?.validationStatus)">
                                    {{ getFieldValidation(field.key)?.validationStatus }}
                                </span>
                                <div class="field-note" *ngIf="getFieldValidation(field.key)?.correctedValue">
                                    <small><strong>Corrected value:</strong> {{
                                        getFieldValidation(field.key)?.correctedValue }}</small>
                                </div>
                                <div class="field-note" *ngIf="getFieldValidation(field.key)?.notes">
                                    <small><strong>Note:</strong> {{ getFieldValidation(field.key)?.notes }}</small>
                                </div>
                            </div>
                            <div class="field-actions" [class.field-actions-hidden]="editingFieldKey === field.key">
                                <button mat-icon-button color="primary" matTooltip="Approve"
                                    [disabled]="editingFieldKey === field.key"
                                    (click)="startFieldValidation(field.key, 'approve')">
                                    <mat-icon>check</mat-icon>
                                </button>
                                <button mat-icon-button color="warn" matTooltip="Reject"
                                    [disabled]="editingFieldKey === field.key"
                                    (click)="startFieldValidation(field.key, 'reject')">
                                    <mat-icon>close</mat-icon>
                                </button>
                            </div>
                        </div>
                        <div *ngIf="editingFieldKey === field.key" class="inline-explanation">
                            <mat-form-field *ngIf="editingMode === 'reject'" appearance="outline" floatLabel="always"
                                class="explanation-input" style="height: 80px;">
                                <mat-label>Corrected value</mat-label>
                                <mat-select *ngIf="getCorrectedValueOptions(field.key) as options"
                                    id="field-corrected-value" aria-label="Corrected value"
                                    placeholder="Select an option"
                                    style="--mat-select-placeholder-text-color: grey; height: 48px; display: flex; align-items: center;"
                                    [(ngModel)]="tempCorrectedValue">
                                    <mat-option *ngFor="let option of options" [value]="option">
                                        {{ option }}
                                    </mat-option>
                                </mat-select>
                                <textarea *ngIf="!getCorrectedValueOptions(field.key)" matInput
                                    id="field-corrected-value" aria-label="Corrected value" rows="2"
                                    [(ngModel)]="tempCorrectedValue" placeholder="Enter the correct value"></textarea>
                            </mat-form-field>
                            <mat-form-field appearance="outline" floatLabel="always" class="explanation-input">
                                <mat-label>Note (optional)</mat-label>
                                <textarea matInput id="field-note" aria-label="Note" rows="2"
                                    [(ngModel)]="tempExplanation" placeholder="Enter a note"></textarea>
                            </mat-form-field>
                            <button mat-raised-button color="primary" (click)="submitFieldValidation(field.key)">
                                Submit
                            </button>
                            <button mat-stroked-button color="warn" class="cancel-button" (click)="cancelValidation()">
                                Cancel
                            </button>
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>

            <mat-card class="section-card">
                <mat-card-header>
                    <mat-card-title>Activities</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <div *ngFor="let activity of selectedContract.activities" class="validation-row"
                        [ngClass]="getConfidenceClass(activity.confidence)">
                        <div class="field-content" [matTooltip]="activity.explanation || ''" matTooltipPosition="above">
                            <div class="field-info">
                                <strong>{{ activity.referenceActivityId }}: {{ activity.activityName || 'Activity Name
                                    not present' }}</strong>
                                <span [class]="getCoverageBadgeClass(activity.isBillable)">
                                    {{ getCoverageLabel(activity.isBillable) }}
                                </span>
                                <span class="confidence-pill"
                                    *ngIf="activity.confidence !== undefined && activity.confidence !== null">
                                    {{ activity.confidence | percent:'1.0-0' }}
                                </span>
                                <span *ngIf="activity.validationStatus"
                                    [class]="getStatusBadgeClass(activity.validationStatus)">
                                    {{ activity.validationStatus }}
                                </span>
                            </div>
                            <div class="field-actions" *ngIf="editingActivityId !== activity.id">
                                <button mat-icon-button color="primary" matTooltip="Approve"
                                    (click)="startActivityValidation(activity, 'approve')">
                                    <mat-icon>check</mat-icon>
                                </button>
                                <button mat-icon-button color="warn" matTooltip="Reject"
                                    (click)="startActivityValidation(activity, 'reject')">
                                    <mat-icon>close</mat-icon>
                                </button>
                            </div>
                        </div>
                        <div *ngIf="editingActivityId === activity.id" class="inline-explanation">
                            <mat-form-field appearance="outline" floatLabel="always" class="explanation-input"
                                style="height: 80px;">
                                <mat-label>Corrected value</mat-label>
                                <mat-select id="activity-corrected-value" aria-label="Corrected value"
                                    placeholder="Select an option"
                                    style="--mat-select-placeholder-text-color: grey; height: 48px; display: flex; align-items: center;"
                                    [(ngModel)]="tempCorrectedValue">
                                    <mat-option *ngFor="let option of getActivityCorrectedValueOptions()"
                                        [value]="option">
                                        {{ option }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                            <mat-form-field appearance="outline" floatLabel="always" class="explanation-input">
                                <mat-label>Note (optional)</mat-label>
                                <textarea matInput id="activity-note" aria-label="Note" rows="2"
                                    [(ngModel)]="tempExplanation"
                                    placeholder="Reason for changing Billable classification"></textarea>
                            </mat-form-field>
                            <button mat-raised-button color="primary" (click)="submitActivityValidation(activity)">
                                Submit
                            </button>
                            <button mat-stroked-button color="warn" class="cancel-button" (click)="cancelValidation()">
                                Cancel
                            </button>
                        </div>
                        <div *ngIf="activity.notes" class="explanation">
                            <small><strong>Note:</strong> {{ activity.notes }}</small>
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>

            <mat-card class="section-card">
                <mat-card-header>
                    <mat-card-title>General Spare Parts Coverages</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <div *ngFor="let sparePart of selectedContract.spareParts" class="validation-row"
                        [ngClass]="getConfidenceClass(sparePart.confidence)">
                        <div class="field-content" [matTooltip]="sparePart.explanation || ''"
                            matTooltipPosition="above">
                            <div class="field-info">
                                <strong>{{ sparePart.sparePartName|| 'Spare Part Name not present' }}</strong>
                                <span class="classification-badge" *ngIf="sparePart.category">
                                    {{ sparePart.category }}
                                </span>
                                <span [class]="getSparePartCoverageBadgeClass(sparePart.coverage)">
                                    {{ getSparePartCoverageLabel(sparePart.coverage) }}
                                </span>
                                <span class="confidence-pill"
                                    *ngIf="sparePart.confidence !== undefined && sparePart.confidence !== null">
                                    {{ sparePart.confidence | percent:'1.0-0' }}
                                </span>
                                <span *ngIf="sparePart.validationStatus"
                                    [class]="getStatusBadgeClass(sparePart.validationStatus)">
                                    {{ sparePart.validationStatus }}
                                </span>
                            </div>
                            <div class="field-actions" *ngIf="editingSparePartId !== sparePart.id">
                                <button mat-icon-button color="primary" matTooltip="Approve"
                                    (click)="startSparePartValidation(sparePart, 'approve')">
                                    <mat-icon>check</mat-icon>
                                </button>
                                <button mat-icon-button color="warn" matTooltip="Reject"
                                    (click)="startSparePartValidation(sparePart, 'reject')">
                                    <mat-icon>close</mat-icon>
                                </button>
                            </div>
                        </div>
                        <div *ngIf="editingSparePartId === sparePart.id" class="inline-explanation">
                            <mat-form-field appearance="outline" floatLabel="always" class="explanation-input">
                                <mat-label>Note (optional)</mat-label>
                                <textarea matInput id="sparepart-note" aria-label="Note" rows="2"
                                    [(ngModel)]="tempExplanation"
                                    placeholder="Reason for changing Billable classification"></textarea>
                            </mat-form-field>
                            <button mat-raised-button color="primary" (click)="submitSparePartValidation(sparePart)">
                                Submit
                            </button>
                            <button mat-stroked-button color="warn" class="cancel-button" (click)="cancelValidation()">
                                Cancel
                            </button>
                        </div>
                        <div *ngIf="sparePart.notes" class="explanation">
                            <small><strong>Note:</strong> {{ sparePart.notes }}</small>
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>

        <div class="right-column">
            <mat-card class="pdf-card">
                <mat-card-header>
                    <mat-card-title>Original Document</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <div class="pdf-container">
                        <iframe #pdfIframe [hidden]="!showPdf" class="pdf-iframe" title="Contract document"></iframe>
                        <div *ngIf="pdfState === 'loading'" class="no-pdf" id="pdf-loading">
                            <mat-spinner diameter="24"></mat-spinner>
                            <p>Loading document...</p>
                        </div>
                        <div *ngIf="pdfState === 'error'" class="no-pdf" id="pdf-error">
                            <mat-icon>error_outline</mat-icon>
                            <p>The document could not be loaded.</p>
                            <button mat-stroked-button id="pdf-retry" (click)="retryPdf()">Retry</button>
                        </div>
                        <div *ngIf="!showPdf && pdfState !== 'loading' && pdfState !== 'error'" class="no-pdf">
                            <mat-icon>description</mat-icon>
                            <p>No document available</p>
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
</div>

<!-- Search Filter Modal -->
<div class="modal-backdrop" *ngIf="isSearchModalOpen" (onKeyPress)="closeSearchModal()"></div>
<div class="modal-container" *ngIf="isSearchModalOpen">
    <mat-card class="search-modal-card">
        <mat-card-header>
            <mat-card-title>
                <div class="modal-title-row">
                    <span>Search Filters</span>
                    <button mat-icon-button (click)="closeSearchModal()" matTooltip="Close">
                        <mat-icon>close</mat-icon>
                    </button>
                </div>
            </mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <div class="filter-form">
                <mat-form-field appearance="outline" floatLabel="always">
                    <mat-label>Contract Number</mat-label>
                    <input matInput id="filter-contract-number" aria-label="Contract Number"
                        [(ngModel)]="filters.contractNumber" placeholder="Enter contract number">
                    <mat-icon matPrefix>tag</mat-icon>
                </mat-form-field>

                <mat-form-field appearance="outline" floatLabel="always">
                    <mat-label>Unit ID</mat-label>
                    <input matInput id="filter-unit-id" aria-label="Unit ID" [(ngModel)]="filters.unitId"
                        placeholder="Enter unit ID">
                    <mat-icon matPrefix>precision_manufacturing</mat-icon>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>Contract Type</mat-label>
                    <mat-select [(ngModel)]="filters.contractType">
                        <mat-option [value]="undefined">All</mat-option>
                        <mat-option *ngFor="let contract of contractOptions" [value]="contract">
                            {{ contract }}
                        </mat-option>
                    </mat-select>
                    <mat-icon matPrefix>shield</mat-icon>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>Coverage Type</mat-label>
                    <mat-select [(ngModel)]="filters.coverageType">
                        <mat-option [value]="undefined">All</mat-option>
                        <mat-option *ngFor="let coverage of coverageTypeOptions" [value]="coverage">
                            {{ coverage }}
                        </mat-option>
                    </mat-select>
                    <mat-icon matPrefix>verified_user</mat-icon>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>Validation State</mat-label>
                    <mat-select [(ngModel)]="filters.validated">
                        <mat-option [value]="true">Validated</mat-option>
                        <mat-option [value]="false">Not validated</mat-option>
                    </mat-select>
                    <mat-icon matPrefix>fact_check</mat-icon>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>Contracts per page</mat-label>
                    <mat-select id="filter-page-size" [(ngModel)]="pageSize">
                        <mat-option *ngFor="let size of pageSizeOptions" [value]="size">{{ size }}</mat-option>
                    </mat-select>
                    <mat-icon matPrefix>format_list_numbered</mat-icon>
                </mat-form-field>
            </div>
        </mat-card-content>
        <mat-card-actions class="modal-actions">
            <button mat-stroked-button (click)="clearFilters(); closeSearchModal()">
                <mat-icon>clear</mat-icon>
                Clear Filters
            </button>
            <button mat-raised-button color="primary" (click)="applyFiltersFromModal()">
                <mat-icon>search</mat-icon>
                Apply Filters
            </button>
        </mat-card-actions>
    </mat-card>
</div>